import React, { useState, useEffect, useCallback, useRef } from "react";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import "./style.css"
import { APICall } from "../../../helpers/API/APICalls";
import { insertUpdateGuidelines, getGuidelineDataById } from "../../../helpers/API/APIEndPoints";
import {
  saveRecordMsg,
  updateRecordMsg,
  fileDeletionMsg,
} from "../../../helpers/Constants/Constants";
import { useHistory } from "react-router-dom";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import SubmitButton from "../../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import CancelButton from "../../../ReusableComponents/Buttons/CancelButton/CancelButton";
import ResetButton from "../../../ReusableComponents/Buttons/ResetButton/ResetButton";
import Decrypt2 from "../../../helpers/Cryptography/CryptoJS";
import FormLabel from "../../../ReusableComponents/FormLabel/FormLabel";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import CommonConstants from "../../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../../helpers/Utils/Utils";

function GuidelinesMasterEdit() {
  const [loading, setLoading] = useState(false);
  const [question, setQuestion] = useState("");
  const [sequence, setSequence] = useState();
  const [answer, setAnswer] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [Id, setId] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [editModeIsActive, setEditModeIsActive] = useState(true);
  const [editModeDisableButton, setEditModeDisableButton] = useState(true);
  let formErrorObj = {};
  let state_id = 0;
  let history = useHistory();


  useEffect(() => {
    (async () => {
      state_id = await Decrypt2(getFromEncLocalStorage("tokennumber")); //history?.location?.state?.id;
      if (state_id !== 0 || state_id != "0") {
        getGuidelinesDataByIdApiCall(state_id);
      }
    })();
  }, []);

  const getGuidelinesDataByIdApiCall = async (id) => {
    setLoading(true);
    const data = await APICall(getGuidelineDataById, { Id: id }, "POST");
    console.log(data)
    if (data.message === "Ok") {
      if (data && data.data && data.data[0][0] && data.data[0][0].id) {
        setId(data.data[0][0].id);
        setQuestion(data.data[0][0].Question);
        setAnswer(data.data[0][0].Answer);
        setSequence(data.data[0][0].Sequence);
        setIsActive(data.data[0][0].IsActive);
        setEditModeIsActive(false);
        setEditModeDisableButton(false);
      }
      setLoading(false);
    } else {
      notify(1, data.message);
      setLoading(false);
    }
  };

  const handleFilterChange = async (e, name) => {


    if (name === "question") {
      let n = e.target.value;
      await setQuestion(n);
      var validString = /^[a-zA-Z0-9-.:/%s,?  ]+$/.test(n);
      await setFormErrors({
        ...formErrors,
        ["Question_isEmpty"]: "",
      });

      if (n == "" || n == null || n == undefined) {
        await setFormErrors({
          ...formErrors,
          ["Question_isEmpty"]: "Question cannot be empty",
        });
      } else {
        if (validString == false) {
          // await setFormErrors({
          //   ...formErrors,
          //   ["Question_isEmpty"]: "Special Characters are not allowed",
          // });
        }
      }
    }
    if (name === "sequence") {
      let seq = e.target.value;
      await setSequence(seq);
      var number = Math.floor(seq)
      await setFormErrors({
        ...formErrors,
        ["Sequence_isEmpty"]: "",
      });
      if (seq == "" || seq == null || seq == undefined) {
        await setFormErrors({
          ...formErrors,
          ["Sequence_isEmpty"]: "Sequence cannot be empty",
        });
      } else {
        if (number == false) {
          await setFormErrors({
            ...formErrors,
            ["Sequence_isEmpty"]: "Decimal are not allowed",
          });
        }
      }
    }

    if (name === "answer") {
      let ans = e.target.value;
      await setAnswer(ans);
      var validString = /^[a-zA-Z0-9-,./%s? ]+$/.test(ans);
      await setFormErrors({
        ...formErrors,
        ["Answer_isEmpty"]: "",
      });
      if (ans == "" || ans == null || ans == undefined) {
        await setFormErrors({
          ...formErrors,
          ["Answer_isEmpty"]: "Answet cannot be empty",
        });
      } else if (validString == false) {
        // await setFormErrors({
        //   ...formErrors,
        //   ["Answer_isEmpty"]: "Special Characters are not allowed",
        // });
      } else if (ans.length > 150) {
        await setFormErrors({
          ...formErrors,
          ["Answer_isEmpty"]: "You cannot enter more than 150 characters",
        });
      }
    }

  };
  const checkValidation = async () => {
    var objError = {};
    await setFormErrors({});
    if (question == undefined || question == null || question == "") {
      objError["Question_isEmpty"] = "Question  cannot be empty";
    }
    if (
      sequence == undefined ||
      sequence == null ||
      !(/^[0-9]+$/.test(sequence))
    ) {
      objError["Sequence_isEmpty"] = " Sequence should be numeric";
    }
    if (answer == undefined || answer == null || answer == "") {
      objError["Answer_isEmpty"] = " Answer cannot be empty";
    }
    formErrorObj = objError;
    await setFormErrors(objError);
  };

  const onSubmit = async (action) => {
    if (action == "Submit") {
      await checkValidation();
      const isEmpty = await Object.values(formErrors).every(
        (x) => x === null || x === "" || x == undefined
      );
      setLoading(true);
      if (isEmpty) {
        // alert("validation")
        await insertUpdateGuidelinesData()
        setLoading(false);
      }

    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      history.push({ pathname: "/guidelines-master" });
    }
    setLoading(false);
  };

  const insertUpdateGuidelinesData = async () => {
    let creator = getFromEncLocalStorage("userId")
    let reqBody = {
      Id: Id,
      mode: Id ? "edit" : "create",
      Question: question,
      Sequence: sequence,
      Answer: answer,
      isActive: isActive,
      createdBy: creator
    };

    const res = await APICall(insertUpdateGuidelines, reqBody, "POST");
    console.log(res)
    if (res.message === "Ok") {
      if (res && res.data !== 0) {
        if (Id === 0) {
          notify(0, saveRecordMsg);
          setLoading(false);
        } else if (Id > 0) {
          notify(0, updateRecordMsg);
          setLoading(false);
        }
        history.push({ pathname: "/guidelines-master" });
      }
      setLoading(false);
    } else {
      let errMsg = typeof res?.message === 'string' ? res?.message : res?.message?.message;
      if (!errMsg) {
        errMsg = res?.err;
      }
      notify(1, errMsg);
      setLoading(false);
    }

  }
  const resetFunction = () => {
    setFormErrors({});
    setQuestion("");
    setAnswer("");
    setSequence();

    formErrorObj = {};
  };

  return (
    <>
      <Main active={"guidelines_master"} removeContainer={true}>
        <Loadspinner filename="GuidelinesMasterEdit.js" isLoading={loading} isMiddle="false" />
        <div className="eventGalleryEdit">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4>Master</h4>
              </div>
              <div className="clearfix"></div>
              <div
                className="d-flex align-items-center justify-space-between"
                style={{
                  background: "#e61636",
                  padding: "10px 20px 10px 10px",
                  color: "white",
                  width: "100%",
                }}
              >
                <div className="col-lg-8  headerText">Guidelines</div>
              </div>
              <div className="mx-3">
                <div className="col-lg-12 col-md-12 mt-3">
                  <div className="row">
                    <div className="col-lg-2 col-md-4 col-sm-6 txt-box mt-3">
                      <div className="form-group">
                        {/* <label style={{fontWeight:"bold"}}>
                              Question<sup>*</sup>
                            </label> */}
                        <FormLabel value="Question" />
                        <sup>*</sup>
                      </div>
                    </div>
                    <div className="col-lg-10 col-md-4 col-sm-6 txt-box">
                      <div className="form-group">
                        <InputForm
                          placeholder={""}
                          isDisabled={false}
                          textArea={false}
                          value={question}
                          onChange={(e) => handleFilterChange(e, "question")}
                          style={{ marginTop: "5px" }}
                        />
                        {/* <p style={{ color: "red", fontWeight: "bold" }}>
                              {formErrors["Question_isEmpty"]}
                            </p> */}
                        <ErrorLabel value={formErrors["Question_isEmpty"]} />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-4 col-sm-6 txt-box mt-3">
                      <div className="form-group">
                        {/* <label style={{fontWeight:"bold"}}>
                              Sequence<sup>*</sup>
                            </label> */}
                        <FormLabel value="Sequence" />
                        <sup>*</sup>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-4 col-sm-6 txt-box">
                      <div className="form-group">
                        <InputForm
                          placeholder={""}
                          isDisabled={false}
                          textArea={false}
                          value={sequence}
                          type="number"
                          onChange={(e) => handleFilterChange(e, "sequence")}
                          style={{ marginTop: "5px" }}
                        />
                        {/* <p style={{ color: "red" , fontWeight: "bold"}}>
                              {formErrors["Sequence_isEmpty"]}
                            </p> */}
                        <ErrorLabel value={formErrors["Sequence_isEmpty"]} />
                      </div>
                    </div>
                    <div class="row">
                      <div className="col-lg-2 col-md-4 col-sm-6 txt-box mt-3">
                        <div className="form-group">
                          {/* <label style={{fontWeight:"bold"}}>
                              Answer<sup>*</sup>
                            </label> */}
                          <FormLabel value="Answer" />
                          <sup>*</sup>
                        </div>
                      </div>
                      <div className="col-lg-10 col-md-4 col-sm-6 txt-box">
                        <div className="form-group">
                          <InputForm
                            placeholder={""}
                            isDisabled={false}
                            textArea={true}
                            value={answer}
                            onChange={(e) => handleFilterChange(e, "answer")}
                            style={{ marginTop: "5px" }}
                          />
                          {/* <p style={{ color: "red", fontWeight: "bold" }}>
                              {formErrors["Answer_isEmpty"]}
                            </p> */}
                          <ErrorLabel value={formErrors["Answer_isEmpty"]} />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-4 col-sm-6 txt-box mt-1">
                      <div className="form-group">
                        {/* <label style={{fontWeight:"bold"}}>
                              Active Status<sup>*</sup>
                            </label> */}
                        <FormLabel value="Active Status" />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-4 col-sm-6 txt-box">
                      <div className="custom-checkbox">
                        <input
                          style={{ marginLeft: "5px" }}
                          id="isActive"
                          type="checkbox"
                          onChange={(e) => setIsActive(e.target.checked)}
                          name="isActive"
                          checked={isActive}
                          className="isActive"
                          disabled={editModeIsActive ? true : false}
                          autoComplete={CommonConstants.autoCompleteInput}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-11 col-md-11" style={{ width: "97%" }}>
                    <div className="float-right">
                      <SubmitButton onClick={() => onSubmit("Submit")} />
                      {editModeDisableButton && (
                        <ResetButton onClick={() => onSubmit("Reset")} />
                      )}
                      <CancelButton onClick={() => onSubmit("Cancel")} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Main>
    </>
  );

}
export default GuidelinesMasterEdit;